export enum ThinIcons {}
